module.exports = __webpack_public_path__ + "img/red-fail-title2.4d460d62.png";